import PropTypes from 'prop-types'
import {DialogTitle, DialogContent} from '@mui/material'
import {StyledReportIcon} from './UserFeedbackDashboardStyle'
import {StyledDialog, StyledDialogActions, StyledButton, StyledCancelButton} from './CreateClosePopupStyle'

const CreateClosePopup = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  confirmButtonColor,
  showWarningIcon
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle>
        {showWarningIcon && <StyledReportIcon data-testid='StyledReportIcon' />}
        {title}
      </DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <StyledDialogActions>
        <StyledCancelButton onClick={onClose} variant='outlined'>
          Cancel
        </StyledCancelButton>
        <StyledButton onClick={onConfirm} variant='contained' color={confirmButtonColor}>
          {confirmButtonText}
        </StyledButton>
      </StyledDialogActions>
    </StyledDialog>
  )
}

CreateClosePopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node,
  confirmButtonText: PropTypes.string.isRequired,
  confirmButtonColor: PropTypes.string.isRequired,
  showWarningIcon: PropTypes.bool.isRequired
}

export default CreateClosePopup
